import StaticdataApi from '@lcsc-ui/apis/staticdata';
import ecpCurl, { setContext, asyncAll } from '@lcsc-ui/utils/ecpCurl';
import Head from 'next/head';
import { NextSeo } from 'next-seo';

import API from '@/apis/item';
import MobileDetailPage from '@/components/mobile/DetailPage';
import { useProductAsyncDataEffect } from '@/hooks/useProductAsyncDataEffect';
import getSchema from '@/utils/schema';

export default function MobileItemPage({ webData, price, resourceData, pageUrl }) {
  const { SeoData, JsonLd, MicroData, description } = getSchema({
    webData,
    price,
    resourceData,
    pageUrl,
    platform: 'mobile',
  });

  // 获取商品异步数据
  useProductAsyncDataEffect(webData);

  return (
    <>
      <Head>
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(JsonLd) }} />
      </Head>
      <NextSeo {...SeoData}></NextSeo>
      {MicroData}
      <MobileDetailPage webData={webData} description={description}></MobileDetailPage>
    </>
  );
}

export async function getServerSideProps(context) {
  setContext(context);
  const { params } = context;
  const itemId = params.itemId.replace('.html', '');

  if (!itemId) {
    return {
      notFound: true,
    };
  }

  const [webData, notFound] = await asyncAll([ecpCurl(`${API.itemServe}${itemId}`)]);

  if (notFound) {
    return {
      notFound: true,
    };
  }

  let resourceListApi = StaticdataApi.resourceList;
  if (webData?.isMro) {
    resourceListApi = StaticdataApi.mroResourceList;
  }

  const [resourceData] = await asyncAll([ecpCurl(resourceListApi, { enableCache: true })]);

  const pageUrl = `${resourceData?.projectConfigVO?.lcscItemUrl}/${params?.itemId}`;

  const { productPriceList } = webData?.productRecord || {};

  const price = productPriceList?.length ? productPriceList[productPriceList.length - 1]?.thePrice : '';

  // 删除敏感数据,防止爬虫抓取
  delete webData?.productRecord?.productPriceList;
  delete webData?.productRecord?.productPriceDiscountList;
  delete webData?.productRecord?.entireProductPriceList;

  return {
    props: {
      webData,
      price,
      resourceData,
      pageUrl,
    },
  };
}
